export const LANG_CHANGE = "LANG_CHANGE";
export const SET_FETCH = "SET_FETCH";
export const SET_IS_EAGRI_AUTH = "SET_IS_EAGRI_AUTH";
export const SET_FARM_NAME = "SET_FARM_NAME";
export const SET_SHP_VALIDATION = "SET_SHP_VALIDATION";
export const SET_COUNTRY = "SET_COUNTRY";
